/**
 * helper functions that you can import into your .ts files and use as needed
 * https://www.typescriptlang.org/docs/handbook/modules.html
 * questions? ole@semway.no
 */

import * as moment from 'moment'; // https://momentjs.com/
moment.locale('nb');


/*
 * get array index of object with passed id parameter
 * e.g. useful for splicing away an object with a certain id from an array
 * example: getObjIndex( 5, relations, 'relation_id' ) will find the array index of the relation with relation_id = 5
 * @param id (int - required)
 * @param array (array - required)
 * @param property (which property of the object in the array to check against)
 */
export function getObjIndex( id: number, array = [], property: string = 'id' ) {
	for (var i = 0; i < array.length; ++i) {
        if ( array[i][property] == id ) {
			return i;
		}
	}
    return -1;
}


/*
 * prepend value to array
 * @param value (any - required)
 * @param array (array - required)
 */
export function arrayPrepend(value, array) {
	var newArray = array.slice(0);
	newArray.unshift(value);
	return newArray;
}


export function removeFromArrayByVal(arr, what) {
    var what, a = arguments, L = a.length, ax;
    while (L > 1 && arr.length) {
        what = a[--L];
        while ((ax= arr.indexOf(what)) !== -1) {
            arr.splice(ax, 1);
        }
    }
    return arr;
}


/*
 * find closest parent matching specified tagName
 * similar to jQuery closest() (https://api.jquery.com/closest/)
 * @param parentClass (string, class name without '.' - required). the parent to look for
 * @param el (HTMLElement - required). the current element
 * @return HTMLElement or false if not found
 */
export function findParent (parentClass, el) {

	var classList = el.classList;
	classList = Object.keys( classList ).map( key => classList[key] ); // object to array conversion

    // loop up until parent element is found
    while (el) {
    	classList = el.classList;
    	if ( typeof classList != undefined && typeof classList != 'undefined' && typeof classList != null ) {
    		classList = Object.keys( classList ).map( key => classList[key] ); // object to array conversion
    		if ( classList.indexOf(parentClass) != -1 ) {
    			// return found parent element
    			return el;
    		}
    	}
        el = el.parentNode;
    }
    // return false if no parent element is found
    return false;
};


/*
 * format a date into the format '6. aug, 2017'
 */
export function formatDate( date: string ) {
    let momentDate = moment(date);
    let returnDate = momentDate.format('D') + '. ' + momentDate.format('MMM').replace('.', '') + ', ' + momentDate.format('YYYY');
    return returnDate;
}

/*
 * format a dateTime into time '13:15'
 */
export function formatGetTime( date: string ) {
    let momentDate = moment(date);
    let returnDate = momentDate.format('HH:ss');
    return returnDate;
}

/*
 * create a timeout function
 */
// export function delay(ms: number) {
//     return new Promise(resolve => setTimeout(resolve, ms));
// }
/* helper function for delaying execution of other functions
** by ole fjarestad
*/
export var delay = (function(){
    var timer = 0;
    return function(callback, ms){
        clearTimeout (timer);
        timer = setTimeout(callback, ms);
    };
})();


/*
 * captialize each word function
 */
export function capitalizeWords(str) {
    return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
}



// WEBPACK FOOTER //
// ./src/app/functions.ts